import fly from "../config/flyio";
import urlConstantJs from '../config/ConstantConfig'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  // 初始化
  GetHeaderMenu() {
    return fly.request(
      "/en/common/headerclasstree",
      null,
      {
        method: "GET",
        baseURL: `${urlConstantJs.navURL}`,
        parseJson: true,
        timeout: 1000 * 30
      }
    )
  },

  GetFooterMenu() {
    return fly.request(
      "/en/common/footerclasstree",
      null,
      {
        method: "GET",
        baseURL: `${urlConstantJs.navURL}`,
        parseJson: true,
        timeout: 1000 * 30
      }
    )
  }
};